import { lazy } from 'react';

const CharityRegisteredRGSEAARoute = lazy(
  () =>
    import(
      /* webpackChunkName: "CharityRegisteredRGSEAA" */ '../components/steps/rgseaa-step/RGSEAA'
    ),
);

export default CharityRegisteredRGSEAARoute;
